<div class="panel-body">
    <div x-file-browser="config.rootPath" x-read-only="config.readOnly" x-show-dirs-only="false" style="height: 95%;"></div>
</div>